import { createSlice } from "@reduxjs/toolkit";

export const AlertSlice = createSlice({
    name: "alertSlice",
    initialState: {
        all_payment_alert_data: {
            total_page_count: 1,
            data: []
        },

        all_resale_alert_data: {
            total_page_count: 1,
            data: []
        },
    },
    reducers: {
        // get all payment alert reducer
        getAllPaymentAlertReducer: (state, action) => {
            state.all_payment_alert_data = {
                total_page_count: action?.payload?.total_page_count || 1,
                data: action?.payload?.data || []
            }
        },
        // get all resale alert reducer
        getAllResaleAlertReducer: (state, action) => {
            state.all_resale_alert_data = {
                total_page_count: action?.payload?.total_page_count || 1,
                data: action?.payload?.data || []
            }
        }
    }
})